export const appleStoreLink = 'https://apps.apple.com/gr/app/ferryscanner/id6736605125';
export const googleAppLink = 'https://play.google.com/store/apps/details?id=com.ferryscanner.mobile';

export const isIOS = () => (/iPad|iPhone|iPod/.test(navigator.userAgent));

export const isAndroid = () => (/android/i.test(navigator.userAgent));
